import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';
import { Observable } from '@apollo/client/utilities';

// Configura tu endpoint de GraphQL
const httpLink = new HttpLink({
  uri: process.env.REACT_APP_GRAPHQL_ENDPOINT || 'http://localhost:4000/graphql',
});

// Link de autenticación que añade el token a los headers
const authLink = new ApolloLink((operation, forward) => {
  // Obtén el token del localStorage
  const token = localStorage.getItem('authToken');
  
  console.log('🔑 Token enviado:', token ? 'Token presente' : 'No hay token');
  
  // Añade el token a los headers
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
    }
  });
  
  return forward(operation);
});

// Link de manejo de errores
const errorLink = new ApolloLink((operation, forward) => {
  return new Observable(observer => {
    const subscription = forward(operation).subscribe({
      next: (result) => {
        // Manejo de errores de GraphQL
        if (result.errors) {
          result.errors.forEach((error) => {
            console.error(
              `[GraphQL error]: Message: ${error.message}, Location: ${JSON.stringify(error.locations)}, Path: ${error.path}`
            );
            
            // Si el token expiró o no es válido, redirigir al login
            if (error.message && (error.message.includes('Unauthorized') || error.message.includes('jwt'))) {
              localStorage.removeItem('authToken');
              globalThis.location.href = '/login';
            }
          });
        }
        
        observer.next(result);
      },
      error: (error) => {
        console.error('[Network error]:', error);
        observer.error(error);
      },
      complete: () => {
        observer.complete();
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  });
});

// Combina los links
const link = ApolloLink.from([errorLink, authLink, httpLink]);

// Crea el cliente Apollo
const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          movies: {
            merge(existing, incoming) {
              return incoming;
            },
          },
        },
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});

export default apolloClient;
